import type { FunctionComponent } from 'react';
import React from 'react';

interface ShieldWheelIconProps {
  size?: number;
  color?: string;
}

/**
 * Shield with wheel icon - used in insured page
 */
export const SingleStarIcon: FunctionComponent<ShieldWheelIconProps> = ({ size = 14, color = '#FF3975' }) => {
  return (
    <svg width={size} height={(12 / 14) * size} viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7 0L8.5716 4.83688H13.6574L9.5429 7.82624L11.1145 12.6631L7 9.67376L2.8855 12.6631L4.4571 7.82624L0.342604 4.83688H5.4284L7 0Z"
        fill={color}
      />
    </svg>
  );
};
